wwdev = {};
wwdev.addCookieBarAdvanced = function(opt) {
    var config = jQuery.extend({
        name: 'wielink_avg',
        emptyCSS: false,
        position: 'bottom',
        options: {
            necessary: 'Noodzakelijk',
            analytical: 'Analytisch',
            tracking: 'Tracking'
        },
        inputLabel: 'Sta de volgende cookies toe',
        firstRequired: true,
        buttonText: 'Accepteren',
        reset: false,
        content: '<p>Wij maken gebruik van <a style="text-decoration: underline; color: white;" href="/cookiebeleid/">cookies</a> om de website goed te laten functioneren. <br>Als je onze website gebruikt, gaan wij ervan uit dat je daarvoor toestemming geeft.</p>',
        content: jQuery('#cookiebar-text .message').html()
    }, typeof opt === 'object' ? opt : {});

    /* options */
    var optionshtml = '';
    jQuery.each(config.options, function (key, value) {
        var rchecked = '';
        var labelClass = 'inactive';
        if (config.firstRequired === true && optionshtml === '') {
            rchecked = ' checked disabled';
            labelClass = 'disabled';
        } else {
            cookieName = config.name + '_cookies_' + key;
            if( ! $.cookie(cookieName) || $.cookie(cookieName) === '1' ) {
                rchecked = ' checked';
                labelClass = '';
            }
        }


        optionshtml = optionshtml + '<li class="'+ labelClass +'">' +
            '<input type="checkbox" name="' + key + '" value="1" ' + rchecked + ' id="cookie-' + key + '" />' +
            '<label class="checkbox_label '+ labelClass +'" for="cookie-' + key + '">' + value + '</label></li>';
    });

    var html = '<div class="cookie-bar">' +
        '<div class="cookie-bar-wrapper">' +
        '<div class="cookie-bar-top">' +
        config.content +
        '</div>' +
        '<div class="cookie-bar-bottom">' +
        '<ul><li>' + config.inputLabel + '</li>' + optionshtml + '<li><button newsitetempattribute="" type="button" class="button-type-submit  button-importance--primair">\n' +
        '<span>' + config.buttonText + '<svg class="" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="17px" viewBox="0 0 10 17" enable-background="new 0 0 10 17" xml:space="preserve">\n' +
        '<path fill="none" stroke="#FFFFFF" stroke-width="2" d="M8.5,8.5l-7-7L8.5,8.5z"></path>\n' +
        '<path fill="none" stroke="#FFFFFF" stroke-width="2" d="M8.5,8.5l-7,7L8.5,8.5z"></path>\n' +
        '</svg></span>\n' +
        '</button>' +
        '</div>' +
        '<div class="clear_div"></div>' +
        '</div>' +
        '</div>';
    try {
        if (typeof jQuery.cookie(config.name + '_cookies_accepted') === 'undefined' || config.reset) {
            if (config.position == 'top') {
                jQuery('body').prepend(html);
            } else {
                jQuery('body').append(html);
            }
            // set the clicks
            jQuery(document).ready(function() {
                jQuery('div.cookie-bar').find('input').on('change', function () {
                    if (  jQuery(this).prop('checked') ) {
                        jQuery(this).next().removeClass('inactive');
                    } else {
                        jQuery(this).next().addClass('inactive');
                    }
                })
            });
            jQuery('.cookie-bar button[type="button"]').click(function () {
                jQuery.each(config.options, function (key, value) {
                    console.log(jQuery('#cookie-' + key));
                    if ( jQuery('#cookie-' + key).is(':checked') ) {
                        jQuery.cookie(config.name + '_cookies_' + key, '1', {expires: 365, path: '/'});
                    } else {
                        jQuery.cookie(config.name + '_cookies_' + key, '0', {expires: 365, path: '/'});
                    }
                });
                jQuery.cookie(config.name + '_cookies_accepted', '1', {expires: 365, path: '/'});
                location.href = location.href;
                return false;
            });
        }
    } catch (error) {
        console.log(error);
        console.log('Unable to find the cookie lib.');
    }
};

